/**
 * StatCard — KPI tile no estilo Command Deck:
 * microlabel mono + LED de estado + número grande em mono.
 */
export default function StatCard({ label, value, hint, tone = "default" }) {
  const toneClass =
    tone === "ok"
      ? "text-noc-ok"
      : tone === "warn"
        ? "text-noc-warn"
        : tone === "err"
          ? "text-noc-err"
          : tone === "info"
            ? "text-noc-accent"
            : "text-noc-text";
  const ledClass =
    tone === "ok"
      ? "led-ok"
      : tone === "warn"
        ? "led-warn"
        : tone === "err"
          ? "led-err"
          : tone === "info"
            ? "led-info"
            : "led-off";
  return (
    <div className="card-pad">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-noc-faint">
          {label}
        </span>
        <span className={ledClass} />
      </div>
      <div className={`mt-2 font-mono text-3xl font-semibold tracking-tight ${toneClass}`}>
        {value}
      </div>
      {hint ? (
        <div className="mt-2 text-xs text-noc-muted">{hint}</div>
      ) : null}
    </div>
  );
}
